import { Box, Typography } from "@mui/material";
import BusinessListIcon from "assets/icons/business_list.svg";
import { BusinessList } from "lib/features/businessList/types";
import businessTypeService from "services/business-types-services";
import { myBusinessListStyles } from "styles/BusinessListDirectory/myBusinessList.styles";
import TrashImage from "../../../assets/icons/delete-icon.svg";
interface BusinessCardProps {
  business: BusinessList;
  setSelectedBusiness: React.Dispatch<
    React.SetStateAction<BusinessList | undefined>
  >;
}

const BusinesslistItem = ({
  business,
  setSelectedBusiness,
}: BusinessCardProps) => {
  function deleteBusinessList(id: number) {
    businessTypeService.deleteBusinessList(id).then((response) => {
      console.log("delete response", response);

    window.location.reload();
    });
    console.log("delete business list");
  }
  return (
    <Box
      sx={myBusinessListStyles.businessListCard}
      
    >
      <img src={BusinessListIcon} alt="business-list" />
      <Box sx={myBusinessListStyles.businessListContainer} onClick={() => setSelectedBusiness(business)}>
        
        <Typography style={myBusinessListStyles.businessListCardText}>
          {business.list_name} 
        </Typography>

      </Box>
      <img src={TrashImage} style={{marginLeft:5}} alt="delete" onClick={()=> {deleteBusinessList(business?.id??0)}} />
    </Box>
  );
};

export default BusinesslistItem;
